import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/**
 * API / Service Manager permission helpers (BR1.4).
 * Prefer api_service_management flags from get_user_permission; fall back to permission names.
 */
export default function useApiServicePermissions() {
  const permissions = useSelector((state) => state.userPermissions?.permissions ?? []);
  const permissionsLoaded = useSelector(
    (state) => state.userPermissions?.permissionsLoaded === true
  );
  const apiServiceManagement = useSelector(
    (state) => state.userPermissions?.apiServiceManagement
  );

  return useMemo(() => {
    const hasAsmFlags =
      apiServiceManagement &&
      (apiServiceManagement.view === true || apiServiceManagement.modify === true);

    if (hasAsmFlags) {
      return {
        canModify: !!apiServiceManagement.modify,
        canView: !!apiServiceManagement.view,
        permissions,
        permissionsReady: permissionsLoaded,
      };
    }

    const canModify =
      permissions.includes('SERVICES_RIGHTS') ||
      permissions.includes('ADMIN_RIGHTS');

    const canView =
      canModify ||
      permissions.includes('SERVICES_RIGHTS_VIEW_ONLY');

    return { canModify, canView, permissions, permissionsReady: permissionsLoaded };
  }, [permissions, apiServiceManagement, permissionsLoaded]);
}
